__turbopack_context__.v({
  "hr": "Divider-module__Y-08FW__hr",
});
